import { Dialog, DialogPanel } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import { IoMdClose } from "react-icons/io";
import { ApiDelete } from "../../helper/axiosFunctions";
import { commonToast } from "../../helper/Toast";
import { useState } from "react";
import { useLocation } from "react-router-dom";

export default function DeleteModel({ isDelete, setIsDelete, person, onSuccess }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const { pathname } = useLocation();
  const classId = pathname.split('/')[2];

  const handleRemove = async () => {
    setLoading(true);
    try {
      if (person.role === 'teacher') {
        await ApiDelete(`/contents/classes/${classId}/teachers/${person?.teacherId}`);
        commonToast(t("teacher_removed_successfully"), "success");
      } else if (person.role === 'student') {
        await ApiDelete(`/contents/classes/${classId}/students/${person?.studentId}`);
        commonToast(t("student_removed_successfully"), "success");
      }
      onSuccess?.();
      setIsDelete(false);
    } catch (error) {
      commonToast(error?.data?.error || error?.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Dialog
        open={isDelete}
        as="div"
        className="relative z-30 focus:outline-none"
        onClose={() => {
          setIsDelete(true);
        }}
      >
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 bg-black/35 backdrop-blur-sm">
            <DialogPanel
              transition
              className="w-full relative max-w-sm rounded-3xl bg-white duration-300 ease-out data-[closed]:transform-[scale(95%)] data-[closed]:opacity-0"
            >
              <IoMdClose
                className="absolute right-5 top-5 cursor-pointer"
                fontSize={20}
                onClick={() => {
                  setIsDelete(false);
                }}
              />

              <div className="flex gap-10 p-5 items-center">
                <div>
                  <h3 className="text-xl font-bold pe-5">
                    {t("remove")} {person?.firstName} {person?.lastName} {t("fromclass")}
                  </h3>
                  <h4 className="regular-text">{t("dltmsg")}</h4>
                </div>
              </div>
              <div className="flex justify-between px-5 pb-5 gap-5 items-center medium-text">
                <button
                  className="secondary-btn w-full"
                  onClick={() => {
                    setIsDelete(false);
                  }}
                  disabled={loading}
                >
                  {t("cancel")}
                </button>
                <button
                  className="primary-btn w-full"
                  onClick={handleRemove}
                  disabled={loading}
                >
                  {loading ? t("removing") + "..." : t("remove")}
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
